import { Modal } from "react-bootstrap";
import styled from "styled-components";

export const BrandFollowersWrapperModal = styled(Modal)`
  .modal-header {
    .modal-title {
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      color: #1f1f1f;
    }
  }
  .modal-body {
    padding: 24px;
    height: calc(100vh - 200px);
    display: flex;
    flex-direction: column;
    gap: 24px;

    .notes-wrapper {
      display: flex;
      flex-direction: column;
      padding: 8px 12px;
      border-radius: 12px;
      background: var(
        --Warning-8,
        linear-gradient(
          0deg,
          rgba(245, 159, 0, 0.08) 0%,
          rgba(245, 159, 0, 0.08) 100%
        ),
        #fff
      );

      h5 {
        overflow: hidden;
        color: var(--warning-100);
        text-overflow: ellipsis;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      p {
        color: var(--Neutral-80);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.12px;
      }
    }

    ul {
      display: flex;
      flex-direction: column;
      gap: 24px;

      li {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .brand-name {
          strong {
            color: var(--Neutral-80);
            font-size: 14px;
            font-weight: 400;
            line-height: 16px;
            letter-spacing: -0.12px;
          }

          color: var(--Neutral-100);
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: -0.14px;

          .link-wrapper {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 400px;
          }

          a {
            color: var(--Neutral-100);
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.14px;
            text-decoration: underline;
          }
        }
      }
    }
  }

  .modal-footer {
    padding: 16px;
    height: 96px;
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--Neutral-8);

    button {
      width: 100%;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
